<template>
  <!-- 外层容器 -->
  <div class="relative w-full h-[58.65vw] py-[3.75vw]">
    <el-image
      class="absolute top-0 left-0 w-full h-full"
      :src="backgroundImage"
      lazy
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#ffffff] font-harmony font-bold leading-[3.25vw] text-center"
        >
          加盟流程
        </div>
      </div>
    </div>

    <!-- 容器区域 -->

    <div class="w-[61.46vw] h-auto relative mx-auto cursor-default">
      <!-- 右侧步骤 -->
      <div
        class="w-[23.8vw] right-0 top-0 absolute inline-flex flex-col justify-start items-start gap-[2.55vw]"
      >
        <div
          v-for="(step, index) in leftSteps"
          :key="'left-' + index"
          class="self-stretch pl-[1.67vw] relative inline-flex justify-start items-center"
          @mouseover="activeStep = parseInt(step.number)"
          @mouseout="activeStep = null"
        >
          <div
            class="min-h-[7.86vw] h-auto w-full p-[1.25vw] rounded-[0.625vw] inline-flex flex-col justify-start items-start gap-[0.42vw] transition-colors duration-300"
            :class="
              activeStep === parseInt(step.number) ? 'bg-[#F28334]' : 'bg-white'
            "
          >
            <!-- 数字和标题 -->
            <div
              class="self-stretch inline-flex justify-start items-start gap-[0.42vw] transition-colors duration-300"
              :class="
                activeStep === parseInt(step.number)
                  ? 'text-[#FFFFFF]'
                  : 'text-[#1a2233]'
              "
            >
              <div class="justify-start text-[1.04vw] font-bold font-harmony">
                {{ step.number }}
              </div>
              <div class="justify-start text-[1.04vw] font-bold font-harmony">
                {{ step.title }}
              </div>
            </div>
            <!-- 具体内容 -->
            <div
              class="self-stretch text-justify justify-start text-opacity-60 text-[0.75vw] font-normal font-harmony leading-normal transition-colors duration-300"
              :class="
                activeStep === parseInt(step.number)
                  ? 'text-[#FFFFFFA6]'
                  : 'text-[#9ca2af]'
              "
            >
              {{ step.description }}
            </div>
          </div>
          <div
            class="w-[1.25vw] h-[1.25vw] left-[1.67vw] top-[2.34vw] absolute origin-top-left rotate-45 transition-colors duration-300"
            :class="
              activeStep === parseInt(step.number) ? 'bg-[#F28334]' : 'bg-white'
            "
          ></div>
        </div>
      </div>
      <!-- 左侧步骤 -->
      <div
        class="w-[23.8vw] left-0 top-[5.05vw] absolute inline-flex flex-col justify-start items-start gap-[2.6vw]"
      >
        <div
          v-for="(step, index) in rightSteps"
          :key="'right-' + index"
          class="self-stretch pr-[1.67vw] relative inline-flex justify-end items-center"
          @mouseover="activeStep = parseInt(step.number)"
          @mouseout="activeStep = null"
        >
          <div
            class="min-h-[7.86vw] h-auto w-full p-[1.25vw] rounded-[0.625vw] inline-flex flex-col justify-start items-start gap-[0.42vw] transition-colors duration-300"
            :class="
              activeStep === parseInt(step.number) ? 'bg-[#F28334]' : 'bg-white'
            "
          >
            <!-- 数字和标题 -->
            <div
              class="self-stretch inline-flex justify-start items-start gap-[0.42vw] transition-colors duration-300"
              :class="
                activeStep === parseInt(step.number)
                  ? 'text-[#FFFFFF]'
                  : 'text-[#1a2233]'
              "
            >
              <div class="justify-start text-[1.04vw] font-bold font-harmony">
                {{ step.number }}
              </div>
              <div class="justify-start text-[1.04vw] font-bold font-harmony">
                {{ step.title }}
              </div>
            </div>
            <!-- 具体内容 -->
            <div
              class="self-stretch text-justify justify-start text-[#9ca2af] text-[0.75vw] font-normal font-harmony leading-normal transition-colors duration-300"
              :class="
                activeStep === parseInt(step.number)
                  ? 'text-[#FFFFFFA6]'
                  : 'text-[#9ca2af]'
              "
            >
              {{ step.description }}
            </div>
          </div>
          <div
            class="w-[1.25vw] h-[1.25vw] right-[0.45vw] top-[2.34vw] absolute origin-top-left rotate-45 transition-colors duration-300"
            :class="
              activeStep === parseInt(step.number) ? 'bg-[#F28334]' : 'bg-white'
            "
          ></div>
        </div>
      </div>

      <!-- 其他静态元素 -->
      <!-- 统一垂直定位容器 -->
      <div
        class="absolute left-1/2 -translate-x-1/2 top-0 h-full w-full flex flex-col items-center gap-[5.23vw] pt-[2.54vw]"
      >
        <!-- 垂直轮廓线 -->
        <div
          class="w-0 h-[43.13vw] left-1/2 -translate-x-1/2 top-[0.05vw] absolute outline outline-[0.05vw] outline-offset-[-0.03vw] outline-white"
        ></div>

        <!-- 圆形与箭头组合 -->
        <div
          v-for="(item, index) in circles"
          :key="'circle-' + index"
          class="relative w-full h-[1.25vw]"
        >
          <!-- 圆形 -->
          <div
            class="absolute left-1/2 -translate-x-1/2 w-[1.25vw] h-[1.25vw] flex items-center justify-center"
            @mouseover="activeStep = item.number"
            @mouseout="activeStep = null"
          >
            <div
              class="absolute inset-0 rounded-full bg-white border-[0.16vw] transition-colors duration-300"
              :class="
                activeStep === item.number ? 'border-[#F28334]' : 'border-white'
              "
            ></div>
            <div class="relative text-[#1a2233] text-[0.625vw] font-bold">
              {{ item.number }}
            </div>
          </div>

          <!-- 箭头指示横线 -->
          <div
            class="absolute left-[calc(50%-0.58vw)] top-1/2 -translate-y-1/2 w-[0.5vw] h-[0.5vw] mt-[2.5vw]"
          >
            <i class="el-icon-arrow-down text-white text-[1.2vw] transform"></i>
          </div>

          <!-- 底部轮廓横线 -->
          <div
            class="absolute top-1/2 w-[7vw] mt-[0.6vw] outline-[0.05vw] outline-dashed transition-colors duration-300"
            :class="[
              activeStep === item.number
                ? 'outline-[#F28334]'
                : 'outline-white',
              index % 2 === 0
                ? 'left-[calc(50%+0.8vw)]'
                : 'right-[calc(50%+0.8vw)]',
            ]"
          ></div>
        </div>
      </div>
    </div>

    <!-- 按钮容器 -->
    <el-button
      native-type="submit"
      class="absolute left-1/2 -translate-x-1/2 bottom-[3.75vw] mx-auto flex justify-center items-center custom-button"
      @mouseenter="hoverButton = true"
      @mouseleave="hoverButton = false"
      @click="smoothScrollToBottom"
    >
      申请加盟
    </el-button>
  </div>
</template>

<script>
import {EventBus} from "@/utils/bus";

export default {
  name: "joinus-module3",
  data() {
    return {
      backgroundImage: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/joinus/module3/sample1.png`,
      activeStep: null, // 新增的响应式变量，用于跟踪鼠标悬停的步骤
      leftSteps: [
        {
          number: "1.",
          title: "意向咨询",
          description:
            "代理商可通过电话、网络、实地考察等多种方式，详细了解公司的加盟政策、产品体系、服务内容等信息。公司将安排专业人员为代理商提供咨询服务，解答疑问。",
        },
        {
          number: "3.",
          title: "考察审核",
          description:
            "公司将对申请人进行实地考察，深入了解申请人的经营场地、团队情况、市场资源等，评估其是否具备加盟条件和运营能力。考察结束后，公司将根据考察结果进行综合评估。",
        },
        {
          number: "5.",
          title: "缴纳费用",
          description:
            "代理商按照合同约定，及时缴纳加盟费、保证金等相关费用。费用缴纳完成后，公司将启动后续的支持服务。",
        },
        {
          number: "7.",
          title: "开业筹备",
          description:
            "代理商进行店面装修、人员招聘、设备采购等开业前准备工作。公司将提供装修设计指导、人员招聘建议、设备采购清单等支持，确保开业筹备工作的顺利进行。",
        },
      ],
      rightSteps: [
        {
          number: "2.",
          title: "提交申请",
          description:
            "在充分了解加盟信息后，代理商需填写加盟申请表，并提交相关资料，包括营业执照、法人身份证明等。公司将对申请资料进行初步审核。",
        },
        {
          number: "4.",
          title: "签订合同",
          description:
            "签订合同 通过审核后，双方签署合作协议，明确各方权利义务。",
        },
        {
          number: "6.",
          title: "培训准备",
          description:
            "公司为代理商提供专业培训，包括品牌文化、产品知识、教学方法、市场推广等方面的培训。代理商需组织员工参加培训，为开业做好充分准备。",
        },
        {
          number: "8.",
          title: "正式运营",
          description:
            "在公司的指导下，代理商正式开展业务。公司将持续关注代理商的运营情况，提供后续的技术支持、市场推广支持、教学服务支持等，帮助代理商解决运营过程中遇到的问题。",
        },
      ],
      // 圆形与数字对
      circles: Array.from({ length: 8 }, (_, i) => ({ number: i + 1 })), // 箭头指示横线，其余属性固定，仅 top 值不同
    };
  },
  methods: {
    // 平滑滚动到底部
    smoothScrollToBottom() {
      // const targetScroll = document.documentElement.scrollHeight;
      // const startPosition = window.scrollY || window.pageYOffset;
      // const distance = targetScroll - startPosition;
      // let startTime = null;
      //
      // function animation(currentTime) {
      //   if (!startTime) startTime = currentTime;
      //   const timeElapsed = currentTime - startTime;
      //   const run = easeInOutQuad(timeElapsed, startPosition, distance, 1000);
      //   window.scrollTo(0, run);
      //   if (timeElapsed < 1000) requestAnimationFrame(animation);
      // }
      //
      // function easeInOutQuad(t, b, c, d) {
      //   t /= d / 2;
      //   if (t < 1) return (c / 2) * t * t + b;
      //   t--;
      //   return (-c / 2) * (t * (t - 2) - 1) + b;
      // }
      //
      // requestAnimationFrame(animation);
        EventBus.$emit('scroll-to-join', 'join5');
    },
  },
};
</script>

<style scoped>
/* 自定义按钮样式 */
.custom-button {
  width: 6.67vw;
  height: 2.92vw;
  background: #f28334 !important;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s;
}

.custom-button :deep(span) {
  color: white;
  font-size: 1.04vw;
  font-weight: bold;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  transform: translateX(-50%) scale(1.05);
  box-shadow: 0 0.2vw 0.6vw rgba(242, 131, 52, 0.5);
}
</style>
